/* eslint-disable react/require-default-props */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-shadow */
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import bindMethods from 'auto-bind';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';

import { generateAssetMediaInformation } from '../../utils/assetDetails/generateAssetMediaInformation';
import { updateMediaInformation, DEFAULT_MESSAGE } from '../../state/previewAsset';
import { VAULT_MEDIA_TYPE } from '../../constants/vault';
import { DARK_GREY } from '../VirtualClipper/constants/theme';
import VideoContent from './VideoContent';
import ImageContent from './ImageContent';
import EmptyContent from './EmptyContent';
import AudioContent from './AudioContent';

const Container = styled.div`
  width: 100%;
  position: relative;
  background-color: ${DARK_GREY};
`;

class MediaContent extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);
  }

  async componentDidUpdate(prevProps) {
    const { rawAssetDetails, isQuerying, selectedUseAs } = this.props;
    const isAssetSelected = rawAssetDetails?._id !== undefined;
    const newSearchTriggered = isQuerying && !prevProps.isQuerying;
    const isUseAsAdded = isEmpty(prevProps.selectedUseAs) && !isEmpty(selectedUseAs);
    const isUseAsChanged = !isEmpty(prevProps.selectedUseAs) && !isEqual(selectedUseAs, prevProps.selectedUseAs);

    if (rawAssetDetails !== prevProps.rawAssetDetails && isAssetSelected) {
      const { updateMediaInformation } = this.props;
      const assetMediaInformation = await generateAssetMediaInformation(rawAssetDetails);
      updateMediaInformation(assetMediaInformation);
    }

    if (newSearchTriggered || isUseAsAdded || isUseAsChanged) {
      const { updateMediaInformation } = this.props;
      updateMediaInformation({ type: null, source: null, message: DEFAULT_MESSAGE });
    }
  }

  render() {
    const {
      mediaInformation: {
        type, source, fullSizeSource, photoRotation,
      },
    } = this.props;
    const {
      video, clip, liveVideo, audio,
    } = VAULT_MEDIA_TYPE;

    return (
      <Container id="AssetDetails.MediaContent">
        {!type || !source ? (
          <EmptyContent /> // unknown asset type or media source unavailable
        ) : type === video || type === clip || type === liveVideo ? (
          <VideoContent videoUrl={source} /> // asset which contains valid video url
        ) : type === audio ? (
          <AudioContent sourceUrl={source} />
        ) : (
          <ImageContent imageUrl={source} fullSizeImageUrl={fullSizeSource} photoRotation={photoRotation} /> // asset which contains preview/thumbnail image
        )}
      </Container>
    );
  }
}

MediaContent.propTypes = {
  rawAssetDetails: PropTypes.object.isRequired, // supplied from Redux
  mediaInformation: PropTypes.object.isRequired, // supplied from Redux
  updateMediaInformation: PropTypes.func.isRequired, // supplied from Redux
  isQuerying: PropTypes.bool.isRequired, // supplied from Redux
  selectedUseAs: PropTypes.object, // supplied from Redux
};

const mapStateToProps = (state) => ({
  rawAssetDetails: state.rawAssetDetails,
  mediaInformation: state.previewAsset.mediaInformation,
  isQuerying: state.search.isQuerying,
  selectedUseAs: state.user.impersonation.user,
});

const mapDispatchToProps = {
  updateMediaInformation,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MediaContent);
